export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/orders.worker.a70c27c3.worker.js");
}
